import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals'

async function enableMocking(): Promise<unknown> {
  if (import.meta.env.DEV && import.meta.env.VITE_MSW_ENABLED === 'true') {
    const { worker } = await import('./mocks')

    return worker.start({
      onUnhandledRequest: 'bypass',
    })
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})

reportWebVitals()
